<template>
  <div>
    <div class="container">
      <el-button size="small" @click="$router.back()">返回</el-button>
    </div>
    <div class="container">
      <el-form label-width="80px" label-position="left">
        <el-form-item label="课程名称">
          <el-col span="6">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="课程价格">
          <el-col span="6">
            <el-input type="number" v-model="form.amount">
              <template slot="append"
                >元</template
              >
            </el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="课程图片">
          <upload-file :limit="10" accept="image/*" v-model="form.imagelistList"></upload-file>
        </el-form-item>

        <el-form-item label="课程简介">
          <el-col span="6">
            <el-input type="textarea" v-model="form.introduction"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="详情图片">
          <upload-file :limit="10" accept="image/*" v-model="form.descriptionimagelistList"></upload-file>
        </el-form-item>

        <el-form-item label="名师">
          <el-select placeholder="请选择老师" multiple v-model="form.teacheridlistList">
            <el-option v-for="teacher in teacherlist" :key="teacher.id" :label="teacher.name" :value="teacher.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="明星学员">
          <el-select placeholder="请选择学生" multiple v-model="form.studentidlistList">
            <el-option v-for="student in studentlist" :key="student.id" :label="student.name" :value="student.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开课时间" style="width:300px;">
          <el-date-picker v-model="form.begintime" type="datetime" value-format="timestamp" placeholder="选择日期时间"> </el-date-picker>
        </el-form-item>

        <el-form-item label="结课时间">
          <el-date-picker v-model="form.endtime" type="datetime" value-format="timestamp" placeholder="选择日期时间"> </el-date-picker>
        </el-form-item>

        <el-form-item label="报名截止">
          <el-date-picker v-model="form.applyendtime" type="datetime" value-format="timestamp" placeholder="选择日期时间"> </el-date-picker>
        </el-form-item>
      </el-form>
    </div>

    <div class="container">
      <el-button v-if="$route.query.id" type="primary" @click="onUpdate">更新</el-button>
      <el-button v-else type="primary" @click="onCreate">创建</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';
import uploadFile from '../../components/uploadFile/index.vue';

export default {
  components: {
    uploadFile: uploadFile
  },
  data() {
    return {
      token: getToken(),
      teacherlist: [],
      studentlist: [],
      form: {
        name: '',
        amount: '',
        imagelistList: [],
        introduction: '',
        descriptionimagelistList: [],
        teacheridlistList: [],
        studentidlistList: [],
        begintime: '',
        endtime: '',
        applyendtime: ''
      }
    };
  },
  created() {
    rpc(
      'StoreTeacherService.GetTeacherList',
      M('TeacherListQueryRequest', {
        token: M('Token', { token: this.token }),
        count: 100
      })
    ).then(res => {
      const list = res.teacherlistList;
      this.teacherlist = list;
    });

    rpc(
      'StoreStudentService.GetStudentList',
      M('StudentListQueryRequest', {
        token: M('Token', { token: this.token }),
        count: 100
      })
    ).then(res => {
      const list = res.studentlistList;
      this.studentlist = list;
    });

    if (this.$route.query.id) {
      rpc(
        'StoreCourseService.GetCourse',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: this.$route.query.id
        })
      ).then(res => {
        res.begintime = new Date(res.begintime * 1000).getTime();
        res.endtime = new Date(res.endtime * 1000).getTime();
        res.applyendtime = new Date(res.applyendtime * 1000).getTime();
        res.amount = res.amount / 100;

        this.form = res;
      });
    }
  },
  methods: {
    onCreate() {
      const form = JSON.parse(JSON.stringify(this.form));
      form.begintime = parseInt(new Date(form.begintime).getTime() / 1000);
      form.endtime = parseInt(new Date(form.endtime).getTime() / 1000);
      form.applyendtime = parseInt(new Date(form.applyendtime).getTime() / 1000);
      form.amount = Number(form.amount).toFixed(2) * 100;

      rpc(
        'StoreCourseService.CreateCourse',
        M('CourseWithTokenRequest', {
          token: M('Token', { token: getToken() }),
          course: M('Course', form)
        })
      ).then(res => {
        this.$router.back();
      });
    },
    onUpdate() {
      const form = JSON.parse(JSON.stringify(this.form));
      form.begintime = parseInt(new Date(form.begintime).getTime() / 1000);
      form.endtime = parseInt(new Date(form.endtime).getTime() / 1000);
      form.applyendtime = parseInt(new Date(form.applyendtime).getTime() / 1000);
      form.amount = Number(form.amount).toFixed(2) * 100;
      rpc(
        'StoreCourseService.UpdateCourse',
        M('CourseWithTokenRequest', {
          token: M('Token', { token: getToken() }),
          course: M('Course', form)
        })
      ).then(res => {
        this.$router.back();
      });
    }
  }
};
</script>

<style></style>
